import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { CostComparison } from './components/CostComparison';
import { Visualization } from './components/Visualization';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { EmotionalClose } from './components/EmotionalClose';
import { LegalNotice } from './components/LegalNotice';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { PRICE_VALUE } from './components/Shared';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="23u9v6r043jyv">
    <p className="text-xl font-extrabold italic leading-relaxed text-blue-900/85 md:text-3xl" data-id="element-1" data-mp="3ijxoypkvdyjd">
      🌿 YOUR NEXT SESSION CAN BEGIN WITH CLARITY — NOT DOUBT.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    document.title = 'Biodecoding Practitioner Kit™ | Lumen Akasha™';
    document.documentElement.lang = 'en';
    const description = 'A complete professional toolkit of session frameworks, integration practices, guided questions, and practitioner resources. 3 Core Volumes + 5 Bonuses · 245+ pages for US$19.99.';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Biodecoding Practitioner Kit',
      content_type: 'product',
      value: PRICE_VALUE,
      currency: 'USD'
    });
  }, []);
  return <div className="min-h-screen w-full bg-stone-50 font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-2" data-mp="35gld2do25ji">
      <UrgencyBanner data-id="element-3" data-mp="3ucjc5sple9t7" />
      <main data-id="element-4" data-mp="3uf5hdlp0gd89">
        <Hero data-id="element-5" data-mp="d4o09u01u88q" />
        <PackContents data-id="element-6" data-mp="d57fv4288kjl" />
        <InitialTestimonials data-id="element-7" data-mp="d3cujon1mqez" />
        <PainPoints data-id="element-8" data-mp="d2l8p5j9071w" />
        <Visualization data-id="element-9" data-mp="85l12q6r2w8o" />
        <LaunchOffer data-id="element-10" data-mp="85bb32lpgp2z" />
        <MoreTestimonials data-id="element-11" data-mp="86w60tbxma1d" />
        <FAQ data-id="element-12" data-mp="83i23gnmdsrt" />
        <CostComparison data-id="element-13" data-mp="3gle7gc7darc0" />
        <TransitionPhrase data-id="element-14" data-mp="3gkuy3jvs9b9l" />
        <EmotionalClose data-id="element-15" data-mp="3gm65ruscn35z" />
        <LegalNotice data-id="element-16" data-mp="3gja7u6gi4ehj" />
      </main>
      <Footer data-id="element-17" data-mp="3bmtixa1h9w3e" />
      <FloatingNotification data-id="element-18" data-mp="3bn2zy84joswy" />
    </div>;
}